export default __webpack_public_path__ + "5913b2509ae301309135c047f8fcd694.svg";